// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
  max-height: 72px;
}

/* QR Modal */
::ng-deep .qrcode img {
  cursor: pointer;
}

#qrImageModal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
}
#qrImageModal ::ng-deep .qrcode {
  height: 100%;
  padding: 30px;
}
#qrImageModal ::ng-deep .qrcode img {
  display: block;
  margin: auto;
  max-width: 100%;
  max-height: 100%;
}

.qrimgcode ::ng-deep div img {
  width: 150px;
  height: auto;
}
@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
.close {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 45px;
  transition: 0.3s;
  color: #b4bdce;
}

.close:hover,
.close:focus {
  cursor: pointer;
  color: #7987a1;
}

#overlay {
  position: fixed;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/enforce-push-enrollment/enforce-push-enrollment.component.scss","webpack://./src/assets/scss/bootstrap/_variables.scss"],"names":[],"mappings":"AAEA;EACI,gBAAA;AADJ;;AAGA,aAAA;AAEA;EACI,eAAA;AADJ;;AAIA;EACE,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AADF;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;AAEI;EACI,cAAA;EACF,YAAA;EACA,eAAA;EACA,gBAAA;AAAN;;AAQM;EACE,YAAA;EACA,YAAA;AALR;AAqBA;EACE;IACE,mBAAA;EAVF;EAaA;IACE,mBAAA;EAXF;AACF;AAcA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cChE8B;ADoDhC;;AAeA;;EAEE,eAAA;EACA,cCpE8B;ADwDhC;;AAeA;EACE,eAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AAZF","sourcesContent":["@import \"../../../assets/scss/bootstrap/_variables.scss\";\n\n.logo {\n    max-height: 72px;\n}\n/* QR Modal */\n\n::ng-deep .qrcode img {\n    cursor: pointer;\n}\n\n#qrImageModal {\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 4;\n  ::ng-deep .qrcode {\n    height: 100%;\n    padding: 30px;\n\n    img {\n        display: block;\n      margin: auto;\n      max-width: 100%;\n      max-height: 100%;\n    }\n  }\n}\n\n.qrimgcode {\n  ::ng-deep {\n    div {\n      img {\n        width: 150px;\n        height: auto;\n      }\n    }\n  }\n}\n\n@-webkit-keyframes zoom {\n  from {\n    -webkit-transform: scale(0)\n  }\n\n  to {\n    -webkit-transform: scale(1)\n  }\n}\n\n@keyframes zoom {\n  from {\n    transform: scale(0)\n  }\n\n  to {\n    transform: scale(1)\n  }\n}\n\n.close {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  font-size: 45px;\n  transition: 0.3s;\n  color: $gray-400;\n}\n\n.close:hover,\n.close:focus {\n  cursor: pointer;\n  color: $gray-600;\n}\n\n#overlay {\n  position: fixed;\n  background: rgb(0,0,0,.7);\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 3;\n}\n","\n$gray-100:                      #f4f5f8;\n$gray-200:                      #e3e7ed;\n$gray-300:                      #cdd4e0;\n$gray-400:                      #b4bdce;\n$gray-500:                      #97a3b9;\n$gray-600:                      #7987a1;\n$gray-700:                      #596882;\n$gray-800:                      #3b4863;\n$gray-900:                      #1c273c;\n\n$body-color:                    #031b4e;\n\n// Color\n$blue:                          #2b7ba7;\n$green:                         #3bb001;\n$teal:                          #00cccc;\n$pink:                          #f10075;\n$indigo:                        #3CBCDB; //#5b47fb;\n$amber:                         #FFBF00;\n\n// Border\n$border-radius:                 3px;\n$border-color:                  $gray-300;\n\n// Buttons & Inputs\n$btn-focus-box-shadow:          none;\n$btn-active-box-shadow:         none;\n\n// Forms\n$input-border-color:            $gray-300;\n\n// Typography\n$font-family-roboto:            'Roboto', sans-serif;\n$font-family-montserrat:        'Montserrat', sans-serif;\n$font-family-raleway:           'Raleway', sans-serif;\n\n$font-family-secondary:         $font-family-roboto;\n$font-size-base:                .875rem;\n\n$link-hover-decoration:         none;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
